import {
  hasReferralOrPartnerQuery,
  isPartnerLandingUrl,
  isProgramChannelMedium,
} from "@/lib/attribution/program-channel"
import type { NormalizedAttributionPayload, RawAttributionPayload } from "./types"

export function normalizeText(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  if (!trimmed) return null
  return trimmed.toLowerCase()
}

export function normalizeUrl(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  if (!trimmed) return null
  return trimmed
}

/** Trim only. Click IDs are case-sensitive for Ads/Meta — never lowercase. */
export function normalizeClickId(value: string | null | undefined): string | null {
  return normalizeUrl(value)
}

export function normalizeAttributionPayload(raw: RawAttributionPayload): NormalizedAttributionPayload {
  return {
    anonymousId: raw.anonymousId,
    sessionId: raw.sessionId,
    source: normalizeText(raw.source ?? null),
    medium: normalizeText(raw.medium ?? null),
    campaign: normalizeText(raw.campaign ?? null),
    content: normalizeText(raw.content ?? null),
    term: normalizeText(raw.term ?? null),
    gclid: normalizeClickId(raw.gclid ?? null),
    fbclid: normalizeClickId(raw.fbclid ?? null),
    ttclid: normalizeClickId(raw.ttclid ?? null),
    gbraid: normalizeClickId(raw.gbraid ?? null),
    wbraid: normalizeClickId(raw.wbraid ?? null),
    fbp: normalizeClickId(raw.fbp ?? null),
    fbc: normalizeClickId(raw.fbc ?? null),
    gaClientId: normalizeClickId(raw.gaClientId ?? null),
    referrerUrl: normalizeUrl(raw.referrerUrl ?? null),
    landingPage: normalizeUrl(raw.landingPage ?? null),
    currentPage: normalizeUrl(raw.currentPage ?? null),
    rawQuery: raw.rawQuery ?? {},
    occurredAt: raw.occurredAt,
  }
}

// Regra de "visita relevante" alinhada à seção 6 do plano
export function isRelevantVisit(payload: NormalizedAttributionPayload): boolean {
  const hasUtm =
    !!payload.source ||
    !!payload.medium ||
    !!payload.campaign ||
    !!payload.content ||
    !!payload.term

  const hasClickId =
    !!payload.gclid ||
    !!payload.fbclid ||
    !!payload.ttclid ||
    !!payload.gbraid ||
    !!payload.wbraid

  const hasExternalReferrer = !!payload.referrerUrl

  const hasProgramChannel =
    isProgramChannelMedium(payload.medium) && !!payload.source?.trim()

  const hasProgramLanding =
    isPartnerLandingUrl(payload.landingPage) || isPartnerLandingUrl(payload.currentPage)

  const hasProgramQuery = hasReferralOrPartnerQuery(payload.rawQuery)

  return (
    hasUtm ||
    hasClickId ||
    hasExternalReferrer ||
    hasProgramChannel ||
    hasProgramLanding ||
    hasProgramQuery
  )
}

